import { Component, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { NGXLogger } from 'ngx-logger';

@Component({
    selector: 'action-bar',
    templateUrl: './action-bar.component.html',
    styleUrls: ['action-bar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
@UntilDestroy({ checkProperties: true })
export class ActionBarComponent {
  @Output() onSubmit: EventEmitter<any> = new EventEmitter();

  constructor(private logger: NGXLogger) {}

  onSubmitAction(evnt: Event): void {
    this.onSubmit.emit(evnt);
  }
}
